module.exports = __webpack_public_path__ + "static/media/landpage4Desktop.425f58a5.png";